import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="section-inner">
        <div className="about-grid">
          <div className="about-image-wrap">
            <img
              src="/alina3.jpeg"
              alt="Alina Bokovikova"
            />
          </div>
          <div className="about-text">
            <div className="section-label">About</div>
            <h2 className="section-title">
              Where <em>craft</em><br />meets the stage
            </h2>
            <p>
              <strong>Alina Bokovikova</strong> is a costume designer and educator whose work spans
              opera, theater, and dance across the United States.
            </p>
            <p>
              In the <em>San Francisco Bay Area</em> she has designed for{' '}
              <strong>San Francisco Opera</strong>, <strong>Opera Parallèle</strong>,{' '}
              <strong>California Shakespeare Company</strong>, <strong>Opera San Jose</strong>,{' '}
              <strong>TheatreWorks</strong>, and <strong>Cutting Ball Theatre</strong>. In{' '}
              <em>Southern California</em> her credits include <strong>The Old Globe</strong>,{' '}
              <strong>La Jolla Playhouse</strong>, <strong>North Coast Repertory Theatre</strong>,{' '}
              <strong>Cygnet Theatre</strong>, <strong>San Diego Repertory Theatre</strong>, and{' '}
              <strong>New Village Arts</strong>. Her work has also taken her to stages across the{' '}
              <em>Pacific Northwest</em>, the <em>Midwest</em>, and <em>New York</em>.
            </p>
            <p>
              Her practice blends <em>historical rigor</em> with modern deconstructive and sustainable
              methods, enriched by classical drawing, watercolor rendering, palette knife acrylics, and
              mixed-media collage. She currently serves as <strong>Costume Design Coordinator</strong>{' '}
              at the <strong>Academy of Art University, School of Fashion</strong>.
            </p>
            <p>
              Her work was exhibited at the{' '}
              <strong>"Costume Design at the Turn of Century"</strong> exhibition and the{' '}
              <strong>Prague Quadrennial</strong>, and she was featured in{' '}
              <strong>American Theatre Magazine</strong>.
            </p>
            <a className="about-cv-link" href="#resume">
              Resume →
            </a>
            <div className="about-awards">
              <div className="award-item">
                <div className="award-number">100+</div>
                <div className="award-label">Professional &amp; Educational Productions</div>
              </div>
              <div className="award-item">
                <div className="award-number">★★★</div>
                <div className="award-label">Regional Best Costume Design Awards</div>
              </div>
              <div className="award-item">
                <div className="award-number">PQ</div>
                <div className="award-label">Prague Quadrennial Exhibitor</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;